import { useMemo, useState } from 'react';
import {
  PARTNER_COMPANY_FILTER_ALL,
  derivePartnerCompanyFilterOptions,
  filterPartnerCompanies,
  hasActivePartnerCompanyFilters,
} from '../Utils/partnerCompanyFiltersUtils';

export const usePartnerCompanyFilters = (companies) => {
  const [query, setQuery] = useState('');
  const [typeFilter, setTypeFilter] = useState(PARTNER_COMPANY_FILTER_ALL);
  const [paeFilter, setPaeFilter] = useState(PARTNER_COMPANY_FILTER_ALL);
  const [tierFilter, setTierFilter] = useState(PARTNER_COMPANY_FILTER_ALL);
  const [serviceLevelFilter, setServiceLevelFilter] = useState(PARTNER_COMPANY_FILTER_ALL);

  const typeOptions = useMemo(
    () => derivePartnerCompanyFilterOptions(companies, 'typeOfPartner'),
    [companies],
  );

  const paeOptions = useMemo(
    () => derivePartnerCompanyFilterOptions(companies, 'partnerAdoptionEngineer'),
    [companies],
  );

  const tierOptions = useMemo(
    () => derivePartnerCompanyFilterOptions(companies, 'tierStatus'),
    [companies],
  );

  const serviceLevelFilterOptions = useMemo(
    () => derivePartnerCompanyFilterOptions(companies, 'serviceLevel'),
    [companies],
  );

  const filteredCompanies = useMemo(
    () => filterPartnerCompanies(companies, {
      query,
      typeFilter,
      paeFilter,
      tierFilter,
      serviceLevelFilter,
    }),
    [companies, query, typeFilter, paeFilter, tierFilter, serviceLevelFilter],
  );

  const hasActiveFilters = useMemo(
    () => hasActivePartnerCompanyFilters({
      query,
      typeFilter,
      paeFilter,
      tierFilter,
      serviceLevelFilter,
    }),
    [query, typeFilter, paeFilter, tierFilter, serviceLevelFilter],
  );

  const clearFilters = () => {
    setQuery('');
    setTypeFilter(PARTNER_COMPANY_FILTER_ALL);
    setPaeFilter(PARTNER_COMPANY_FILTER_ALL);
    setTierFilter(PARTNER_COMPANY_FILTER_ALL);
    setServiceLevelFilter(PARTNER_COMPANY_FILTER_ALL);
  };

  return {
    query,
    setQuery,
    typeFilter,
    setTypeFilter,
    paeFilter,
    setPaeFilter,
    tierFilter,
    setTierFilter,
    serviceLevelFilter,
    setServiceLevelFilter,
    typeOptions,
    paeOptions,
    tierOptions,
    serviceLevelFilterOptions,
    filteredCompanies,
    hasActiveFilters,
    clearFilters,
  };
};
